import styled from 'styled-components';

export const WeekContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
